
import React from 'react';
import styled from '@emotion/styled';

import { mq, text, black03 } from '../../_style';

export default class ArticleHeading extends React.Component {
  render() {
    const Container = styled.h3`
      color: ${black03};
      ${text('18px', 32 / 18)}
      font-feature-settings: "palt";
      ${this.props.qa === 'true' && 'padding-top: 30px;'}
      ${mq.pc} {
        display: ${this.props.spOnly === 'true' && 'none' };
      }
      ${mq.sp} {
        display: ${this.props.pcOnly === 'true' && 'none'};
      }
    `;
    return(
      <Container>{this.props.children}</Container>
    )
  }
}
